var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentPpt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.99786,7v6h-2V7.82837L14.16943,4H5.99786v9h-2V2h11ZM8.02228,15.833a1.91316,1.91316,0,0,1,.26758,1.02148,1.76223,1.76223,0,0,1-.63575,1.46192,1.68377,1.68377,0,0,1-.668.3164,4.40072,4.40072,0,0,1-1.01075.09473H5.408V21.0166H4.05548V15.01074H5.74689a5.75308,5.75308,0,0,1,1.31836.11426A1.5171,1.5171,0,0,1,8.02228,15.833Zm-1.085,1.06836a.77052.77052,0,0,0-.35157-.7168,1.64309,1.64309,0,0,0-.82226-.15625H5.37384v1.68262h.38965a2,2,0,0,0,.80957-.11914A.69238.69238,0,0,0,6.93732,16.90137Zm7.02948-1.085a1.91316,1.91316,0,0,1,.26758,1.02148,1.7622,1.7622,0,0,1-.63575,1.46191,1.68376,1.68376,0,0,1-.668.31641,4.40057,4.40057,0,0,1-1.01074.09473h-.56738V21H10V14.99414h1.69141a5.75308,5.75308,0,0,1,1.31836.11426A1.51713,1.51713,0,0,1,13.9668,15.81641Zm-1.085,1.06836a.77052.77052,0,0,0-.35157-.7168,1.64312,1.64312,0,0,0-.82226-.15625h-.38965v1.68262H11.708a2,2,0,0,0,.80957-.11914A.69238.69238,0,0,0,12.88184,16.88477Zm2.24963-.81446h1.7373V21.0166h1.35254V16.07031H19.984V15.01074H15.13147Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPpt);
export default __webpack_public_path__ + "static/media/Document-PPT.07b67a6d.svg";
export { ForwardRef as ReactComponent };